/**
 * creator:linhe
 * date:2019/05/29
 * class:对vuex进行封装
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tabIndex: 0, //下方tab的当前选中
    shareShow: false,
    currentPath: '/',
    isIphoneX: false
  },
  mutations: {
    changeTab(state, index) {
      state.tabIndex = index;
    },
    changeShareShow(state, shareShow) {
      state.shareShow = shareShow;
    },
    changeCurrentPath(state, currentPath) {
      state.currentPath = currentPath;
    },
    changeIsIphoneX(state, isIphoneX) {
      state.isIphoneX = isIphoneX;
    }
  },
  actions: {}
});
